<router-outlet></router-outlet>

<div
	*ngIf="isLazyLoadingRouterModule"
	class="lazy-loading-spinner"
	fxLayout="column"
	fxLayoutAlign="center center"
>
	<div>
		<mat-spinner [diameter]="30"></mat-spinner>
	</div>
	<div>
		<h4 class="primary-text">Just a sec. We are getting things together.</h4>
	</div>
</div>

<app-pwa-install-prompt *ngIf="pwaInstallService.shouldShowPrompt$ | async"></app-pwa-install-prompt>
